module.exports = __webpack_public_path__ + "img/686.532606ae.jpg";